"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = exports.setCdr = exports.setCar = exports.cdr = exports.car = exports.mustDoOnPair = exports.cons = void 0;
const value_1 = require("../interpreter/value");
const sExpression_1 = require("../sExpression");
exports.cons = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'cons',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => value_1.makePair(args[0], args[1])
};
const mustDoOnPair = (opName, pair, op) => {
    if (pair.type !== 'pair') {
        throw new Error(opName + ' expects a pair as the only argument, but encountered ' + pair.type);
    }
    return op(pair);
};
exports.mustDoOnPair = mustDoOnPair;
exports.car = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'car',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => exports.mustDoOnPair('car', args[0], (pair) => pair.head)
};
exports.cdr = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'cdr',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: (args) => exports.mustDoOnPair('cdr', args[0], (pair) => pair.tail)
};
exports.setCar = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'set-car!',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => exports.mustDoOnPair('set-car!', args[0], (pair) => {
        pair.head = args[1];
        return sExpression_1.makeEmptyList();
    })
};
exports.setCdr = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'set-cdr!',
    callSignature: {
        style: 'fixed-args',
        numParams: 2
    },
    body: (args) => exports.mustDoOnPair('set-cdr!', args[0], (pair) => {
        pair.tail = args[1];
        return sExpression_1.makeEmptyList();
    })
};
exports.list = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'list',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 0
    },
    body: (args) => value_1.makeList(args)
};
//# sourceMappingURL=pair.js.map